import React from 'react';
import { useGameStore } from '../store/gameStore';
import { GameCard } from './GameCard';

export const GameBoard: React.FC = () => {
  const cards = useGameStore((state) => state.cards);
  const spymasterMode = useGameStore((state) => state.spymasterMode);
  const handleCardClick = useGameStore((state) => state.handleCardClick);

  return (
    <div className="board">
      {cards.map((card, index) => (
        <GameCard
          key={index}
          card={card}
          index={index}
          spymasterMode={spymasterMode}
          onClick={handleCardClick}
        />
      ))}
    </div>
  );
};
